import { NavMenuItem, User } from '@employ-engage/data';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Link } from 'react-router-dom';

export interface AvatarProps {
  user: User;
  menuItems?: NavMenuItem[];
}

export const Avatar = ({ user, menuItems }: AvatarProps) => {
  const displayNameParts = user.displayName?.split(' ') || [];
  const firstInitial = displayNameParts?.[0]?.[0] || '';
  const lastInitial =
    displayNameParts?.[displayNameParts.length - 1]?.[0] || '';

  let initials = '';
  if (!firstInitial && !lastInitial) {
    initials = user.email?.[0] || '';
  } else {
    initials = `${firstInitial}${lastInitial}`;
  }

  return (
    <Popover className="relative">
      <PopoverButton className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
        {user.photoURL ? (
          <img
            className="w-[50.65px] h-[50.65px] rounded-2xl"
            src={user.photoURL}
            alt="Profile"
          />
        ) : (
          <div className="w-[50.65px] h-[50.65px] rounded-2xl bg-light-primary/50 text-2xl text-neutral-900 font-semibold flex justify-center items-center">
            {initials}
          </div>
        )}
      </PopoverButton>

      {(menuItems?.length || 0) > 0 && (
        <PopoverPanel
          transition
          className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
        >
          <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
            {menuItems?.map((item) => {
              if (item.to) {
                return (
                  <Link
                    key={item.title}
                    to={item.to}
                    className="block p-2 hover:text-indigo-600"
                  >
                    <i className={item.iconClassName} /> {item.title}
                  </Link>
                );
              } else if (item.onClick) {
                return (
                  <button
                    key={item.title}
                    onClick={item.onClick}
                    className="block p-2 hover:text-indigo-600"
                  >
                    <i className={item.iconClassName} /> {item.title}
                  </button>
                );
              }
              // A menu item with neither a link nor a handler renders nothing.
              return null;
            })}
          </div>
        </PopoverPanel>
      )}
    </Popover>
  );
};
